import { Helmet } from "react-helmet";



const PageHeader1 = (props: any) => {
  const { title, description, image } = props;

  return (
    <Helmet>
      <link rel="icon" href={image} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="theme-color" content="#000000" />
      <link rel="apple-touch-icon" href={image} />
      {/* <script
        src="//code.tidio.co/yvgramafa9kwnoxpm3bwlus0ort34ooi.js"
        async
      ></script> */}
      <title>{title}</title>
      <meta
        name="twitter:title"
        content="Songplace - The best platform to manage your Spotify playlists"
      />
      <meta itemProp="name" content="Songplace" />
      <meta property="og:title" content="Songplace" />
      <meta name="description" content={description} />
      <meta name="twitter:description" content={description} />
      <meta itemProp="description" content={description} />
      <meta property="og:description" content={description} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@songplace" />
      <meta name="twitter:image" content={image} />
      <meta itemProp="image" content={image} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content="https://www.songplace.io/" />
    </Helmet>
  );
};

export default PageHeader1;
